/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_Point_3Inputs */

const en_svc_research_scope_point_3 = /** @type {(inputs: Svc_Research_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier, tender and regulation monitoring`)
};

const lv_svc_research_scope_point_3 = /** @type {(inputs: Svc_Research_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piegādātāju, iepirkumu un regulējuma uzraudzība`)
};

/**
* | output |
* | --- |
* | "Supplier, tender and regulation monitoring" |
*
* @param {Svc_Research_Scope_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_point_3 = /** @type {((inputs?: Svc_Research_Scope_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_point_3(inputs)
	return en_svc_research_scope_point_3(inputs)
});